import { render, staticRenderFns } from "./Documents.vue?vue&type=template&id=b5873368&scoped=true&"
import script from "./Documents.vue?vue&type=script&lang=js&"
export * from "./Documents.vue?vue&type=script&lang=js&"
import style1 from "./Documents.vue?vue&type=style&index=1&id=b5873368&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5873368",
  null
  
)

export default component.exports